// export const AEM_ASSETS = "/assets"
export const AEM_ASSETS = "https://dyprod-stacker-images.azureedge.net"

export default {
  AEM_ASSETS,
}
